/* eslint-disable react/jsx-no-duplicate-props */
import React, { Component } from 'react'
import {
    Row,
    Col,
    Dropdown,
    Input,
    Button,
    Mentions,
    Avatar,
    Icon,
    Menu,
    Spin,
} from 'antd'
import { Scrollbars } from 'react-custom-scrollbars'

import { FaPlusCircle } from 'react-icons/fa'
import QMAction from '../../redux/quickMessage/actions'
// redux
import { connect } from 'react-redux'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CreateNewMessage from './createNewMessage'
import ShowMessage from './showMessage'
import { IoIosRefresh } from 'react-icons/io'
import scrumBoardActions from '../../redux/scrumBoard/actions'
import objectAction from '../../redux/object/actions'
import mediaAction from '../../redux/qbmedia/actions'
import { FaArrowUp, FaArrowDown } from 'react-icons/fa'
import moment from 'moment'
const { Search } = Input

const { TextArea } = Input
const { Option } = Mentions
const default_avatar = require('../../resource/image/defaultUser.png')

class QuickMessageComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoadList: false,
            isShowCreateNew: false,
            currentMsgID: 0,
            status: 0,
        }
    }
    componentDidMount() {
        if (!this.state.isLoadList) {
            if (this.props.userInfo) {
                this.props.getListmessage(this.props.userInfo.uid, 'All', 1)
                this.setState({ isLoadList: true })
            }
        }
    }
    getName = () => {
        if (this.state.status === 0) {
            return 'Tất cả báo cáo'
        }
        if (this.state.status === 1) {
            return 'Báo cáo nhận về'
        }
        if (this.state.status === 2) {
            return 'Báo cáo gửi đi'
        }
    }

    componentWillReceiveProps(nextprops) {
        if (!this.state.isLoadList) {
            if (nextprops.userInfo) {
                this.props.getListmessage(nextprops.userInfo.uid, 'All', 1)
                this.setState({ isLoadList: true })
            }
        }

        if (this.props.messid) {
            if (nextprops.listMsg !== this.props.listMsg) {
                let index = nextprops.listMsg.findIndex(msg => {
                    return msg.messid === this.props.messid.params.id >> 0
                })
                if (index !== -1) {
                    this.setState({ currentMsgID: index })
                }
            }
        }
    }

    // getCurrentUserinfo = index => {
    //     if (this.props.crrUser[index]) {
    //         return this.props.crrUser[index]
    //     } else {
    //         return {}
    //     }
    // }

    getCurrentOrginfo = oid => {
        if (oid && this.props.listCrrOrg) {
            let info = this.props.listCrrOrg.find(org => {
                return org.oid === oid
            })
            return info
        }
    }

    getCurrentUserinfo = msg => {
        if (msg.owner_id === this.props.userInfo.uid) {
            let id = msg.receiver_uid[0]
            let info = this.props.crrUser.find(vl => {
                return vl.uid === id
            })
            return info
        } else {
            let info = this.props.crrUser.find(vl => {
                return vl.uid === msg.owner_id
            })
            return info
        }
    }
    getListDataMsg = () => {
        if (this.state.status === 0) {
            return this.props.listMsg
        }
        if (this.state.status === 1) {
            let listmsg = this.props.listMsg.filter(vl => {
                return vl.owner_id !== this.props.userInfo.uid
            })

            return listmsg
        }
        if (this.state.status === 2) {
            let listmsg = this.props.listMsg.filter(vl => {
                return vl.owner_id === this.props.userInfo.uid
            })
            return listmsg
        }
    }
    handleScroll = e => {
        const bottom =
            e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
        if (bottom) {
            //default mỗi lần get 40 item message
            if (this.props.totalMessage > this.props.PageNumber * 10) {
                this.props.updateIsloadingMess(true)
                setTimeout(() => {
                    this.props.getListmessage(
                        this.props.userInfo.uid,
                        'All',
                        this.props.PageNumber + 1,
                        true
                    )
                }, 1500)
            }
        }
    }
    componentWillUnmount() {
        console.log('unmount showmessage')
        this.props.getListMediaQueryByIdDone([])
        this.props.getListCurrentEventDone([])
        this.props.getListObjectQueryById_done([])
    }

    render() {
        console.log('this.props.listMsg', this.props.listMsg)
        const menu = (
            <Menu>
                <Menu.Item
                    key="0 "
                    onClick={() => {
                        this.setState({ status: 2, currentMsgID: 0 })
                    }}
                >
                    Báo cáo gửi đi
                </Menu.Item>
                <Menu.Item
                    key="1"
                    onClick={() => {
                        this.setState({ status: 1, currentMsgID: 0 })
                    }}
                >
                    Báo cáo nhận về
                </Menu.Item>
                <Menu.Item
                    key="3"
                    onClick={() => {
                        this.setState({ status: 0, currentMsgID: 0 })
                    }}
                >
                    Tất cả
                </Menu.Item>
            </Menu>
        )
        return (
            <div>
                <Row>
                    <Col
                        span={6}
                        style={{
                            height: window.innerHeight - 80,
                            borderBottomLeftRadius: 7,
                            borderBottomRightRadius: 7,
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundPosition: 'center right',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'auto',
                            backgroundImage: `url(${require('../../resource/image/blur-bg.jpg')}`,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Button
                                type="primary"
                                style={{ width: 150, margin: 10, height: 40 }}
                                onClick={() => {
                                    this.setState({ isShowCreateNew: true })
                                }}
                            >
                                <FaPlusCircle style={{ marginRight: 5 }} />
                                Soạn báo cáo
                            </Button>
                            <Dropdown overlay={menu} trigger={['click']}>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: 'white',
                                        fontSize: 14,
                                        paddingRight: 5,
                                        cursor: 'pointer',
                                    }}
                                >
                                    {this.getName()}
                                    <Icon
                                        style={{ paddingLeft: 5 }}
                                        type="down"
                                    />
                                </div>
                            </Dropdown>
                        </div>
                        <div
                            style={{
                                color: 'white',
                                padding: 10,
                                borderWidth: '0px',
                                borderBottomWidth: '1px',
                                borderBlockColor: 'white',
                                borderStyle: 'solid',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <text>Danh sách báo cáo nhanh</text>
                            <Button
                                type="link"
                                onClick={() => {
                                    this.props.getListmessage(
                                        this.props.userInfo.uid,
                                        'All',
                                        1
                                    )
                                    this.setState({ currentMsgID: 0 })
                                }}
                            >
                                <IoIosRefresh size={25} />
                            </Button>
                        </div>

                        <Search
                            placeholder="Nhập để tìm kiếm"
                            onChange={value => {
                                this.props.getListmessage(
                                    this.props.userInfo.uid,
                                    'All',
                                    1,
                                    value.target.value
                                )
                                this.setState({ currentMsgID: 0 })
                            }}
                            style={{ marginTop: 10, marginBottom: 10 }}
                        />

                        <Scrollbars
                            onScroll={this.handleScroll}
                            style={{ marginBottom: 20 }}
                        >
                            {this.props.isloadingMess && (
                                <div
                                    style={{
                                        justifyContent: 'center',
                                        alignContent: 'center',
                                        display: 'flex',
                                    }}
                                >
                                    <Spin tip="Đang tải dữ liệu..."></Spin>
                                </div>
                            )}
                            {this.props.listMsg &&
                                this.props.crrUser.length > 0 &&
                                this.getListDataMsg().map((msg, index) => (
                                    <div
                                        style={{
                                            color: 'white',
                                            backgroundColor:
                                                index ===
                                                this.state.currentMsgID
                                                    ? '#209e91'
                                                    : 'transparent',
                                            padding: 10,
                                            borderWidth: '0px',
                                            borderBottomWidth: '1px',
                                            borderBlockColor: 'white',
                                            borderStyle: 'solid',
                                            alignContent: 'center',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                currentMsgID: index,
                                                isShowCreateNew: false,
                                            })
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                            }}
                                        >
                                            {msg.receiver_oid.length > 0 && msg.owner_id === this.props.userInfo.uid &&
                                                this.getCurrentOrginfo(
                                                    msg.receiver_oid[0]
                                                ) && (
                                                    <div
                                                        style={{
                                                            fontSize: 10,
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            width: 100,
                                                        }}
                                                    >
                                                        <Avatar
                                                            size={48}
                                                            src={
                                                                this.getCurrentOrginfo(
                                                                    msg.receiver_oid[0]
                                                                ).ext_data.avatarOrgani
                                                            }
                                                            style={{
                                                                padding: 5,
                                                                objectFit:
                                                                    'contain',
                                                            }}
                                                        />
                                                        <text>
                                                            {
                                                                this.getCurrentOrginfo(
                                                                    msg.receiver_oid[0]
                                                                ).name
                                                            }
                                                        </text>
                                                    </div>
                                                )}
                                            {(msg.receiver_oid.length === 0 || msg.owner_id !== this.props.userInfo.uid )&&
                                                this.getCurrentUserinfo(
                                                    msg
                                                )  && (
                                                    <div
                                                        style={{
                                                            fontSize: 10,
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            width: 100,
                                                        }}
                                                    >
                                                        <Avatar
                                                            size={48}
                                                            src={
                                                                this.getCurrentUserinfo(
                                                                    msg
                                                                ).avatar === ''
                                                                    ? default_avatar
                                                                    : this.getCurrentUserinfo(
                                                                          msg
                                                                      ).avatar
                                                            }
                                                            style={{
                                                                padding: 5,
                                                                objectFit:
                                                                    'contain',
                                                            }}
                                                        />
                                                        <text>
                                                            {
                                                                this.getCurrentUserinfo(
                                                                    msg
                                                                ).display_name
                                                            }
                                                        </text>
                                                    </div>
                                                )}
                                            <div
                                                style={{
                                                    fontSize: 13,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    flex: 1,
                                                    marginLeft: 10,
                                                }}
                                            >
                                                <text>
                                                    <b>Tiêu đề: </b>
                                                    {msg.title}
                                                </text>
                                                <text>
                                                    <b>Thời gian: </b>
                                                    {moment(
                                                        msg.created_time * 1000
                                                    ).format('DD/MM/YYYY')}
                                                </text>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {this.props.userInfo.uid ===
                                                msg.owner_id && (
                                                <FaArrowUp color="red" />
                                            )}
                                            {this.props.userInfo.uid !==
                                                msg.owner_id && (
                                                <FaArrowDown color="green" />
                                            )}
                                        </div>
                                    </div>
                                ))}
                            {this.props.isloadingMess && (
                                <div
                                    style={{
                                        justifyContent: 'center',
                                        alignContent: 'center',
                                        display: 'flex',
                                    }}
                                >
                                    <Spin tip="Đang tải dữ liệu..."></Spin>
                                </div>
                            )}
                        </Scrollbars>
                    </Col>
                    <Col
                        span={18}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            paddingTop: 15,
                            height: window.innerHeight,
                        }}
                    >
                        {this.state.isShowCreateNew && (
                            <CreateNewMessage
                                onSendEnd={() => {
                                    this.setState({ isShowCreateNew: false })
                                    this.props.updateIsloadingMess(true)
                                    setTimeout(() => {
                                        this.props.getListmessage(
                                            this.props.userInfo.uid,
                                            'All',
                                            1
                                        )
                                    }, 2500)
                                }}
                            />
                        )}
                        {!this.state.isShowCreateNew &&
                            this.props.crrUser.length > 0 && (
                                <ShowMessage
                                    message={
                                        this.getListDataMsg()[
                                            this.state.currentMsgID
                                        ]
                                    }
                                />
                            )}
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        listUser: state.QMreducer.listUser,
        userInfo: state.auth.userInfo,
        listMsg: state.QMreducer.listMsg,
        crrUser: state.QMreducer.crrUser,
        isloadingMess: state.QMreducer.isloadingMess,
        PageNumber: state.QMreducer.PageNumber,
        totalMessage: state.QMreducer.totalMessage,
        listCrrOrg: state.QMreducer.listCrrOrg,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getListuserByText: text => {
            dispatch(QMAction.action.getListuserByText(text))
        },
        sendMessage: (uid, body) => {
            dispatch(QMAction.action.sendMessage(uid, body))
        },
        getListmessage: (uid, status, page_number, text, isloadmore) => {
            dispatch(
                QMAction.action.getListmessage(
                    uid,
                    status,
                    page_number,
                    text,
                    isloadmore
                )
            )
        },
        updateIsloadingMess: bool => {
            dispatch(QMAction.action.updateIsloadingMess(bool))
        },
        getListMediaQueryByIdDone: data => {
            dispatch(mediaAction.action.getListMediaQueryByIdDone(data))
        },
        getListCurrentEventDone: data => {
            dispatch(scrumBoardActions.getListCurrentEventDone(data))
        },
        getListObjectQueryById_done: data => {
            dispatch(objectAction.action.getListObjectQueryById_done(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuickMessageComponent)
